import { Component, Vue, Prop as prop, Watch as watch, Watch } from 'nuxt-property-decorator';
import { Swiper, Thumbs, Navigation, Zoom } from 'swiper';
import supportsWebP from 'supports-webp'; 

@Component({
    components: {
        sliderPicture: require('~/components/common/image/').default,
    },
})
export default class ImageSliderComponent  extends Vue {

    @prop({required: true})
    public images: string[];

    @prop({required: true})
    public start: number;

    thumbsSwiper = null;

    thumbsGallery: Swiper = null;
    mainGallery: Swiper = null;
    isSupportsWebp = false;

    zoomIcon = 'magnifying-glass-plus';

    mounted() {

        document.body.classList.add('no-scroll');

        supportsWebP.then((value) => {
            this.isSupportsWebp = value;
        })

        this.thumbsGallery = new Swiper(this.$refs['thumbs-slider'] as HTMLElement, {
            modules: [Navigation],
            spaceBetween: 20,
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.arrow.right',
              prevEl: '.arrow.left',
            },
            // loopAddBlankSlides: true,
            loop: true,
            watchSlidesProgress: true,
        });
        
        this.mainGallery = new Swiper(this.$refs['main-slider'] as HTMLElement, {
            modules: [Thumbs, Navigation, Zoom],
            spaceBetween: 20,
            loop: true,
            zoom: true,
            navigation: {
              nextEl: '.arrow.right',
              prevEl: '.arrow.left',
            },
            initialSlide: this.start,
            thumbs: {
              swiper: this.thumbsGallery,
            },
            on: {
                zoomChange: (swiper, scale, imageEl, slideEl) => {
                    this.zoomIcon = scale > 1 ? 'magnifying-glass-minus' : 'magnifying-glass-plus';
                    // console.log(scale)
                },
            }
        });
    }

    zoom() {
        if (this.mainGallery) {
            this.mainGallery.zoom.toggle();
        }
    }

    beforeDestroy() {
        document.body.classList.remove('no-scroll');
        this.mainGallery.destroy();
        this.thumbsGallery.destroy();
    }
}
